import { render } from "./Create.vue?vue&type=template&id=996a0fd8&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=996a0fd8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-996a0fd8"

export default script